
























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import * as api from '@/api';
import * as models from '@/api/models';
@Component
export default class BirthDate extends Vue {
  @Prop() showDatePicker: boolean;
  @Watch('showDatePicker', { deep: true, immediate: true })
  async ShowDatePicker(val: boolean) {
    this.show = val;
  }
  show: boolean = false;

  currentDate: Date = new Date(1980, 0, 1);

  minDate = new Date(1900, 0, 1);
  maxDate = new Date();

  formatter(type: any, val: any) {
    if (type === 'year') {
      return `${val}年`;
    } else if (type === 'month') {
      return `${val}月`;
    }
    return val;
  }

  onConfirm() {
    this.$emit('dateConfirm', this.currentDate);
  }
  onCancel() {
    this.$emit('dateCancel');
  }
}
